<template>
    <el-container class="storesale" style="overflow: auto;height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="新增店销" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main>
            <el-form ref="form" :model="intebostoresale" size="mini" label-width="120px" :rules="rules">
                <el-form-item label="单号" prop="sysbillid">
                    <span>{{intebostoresale.sysbillid}}</span>
                </el-form-item>
                <el-form-item label="店销门店" prop="parentstoreid">
                    <el-cascader :options="storeData" clearable filterable  v-model="parentstoreid" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
                <el-form-item label="店销类型" prop="saletype">
                    <el-radio-group v-model="intebostoresale.saletype">
                        <el-radio :label="1">新店</el-radio>
                        <el-radio :label="2">复打</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="SN码" prop="sn">
                    <el-select v-model="intebostoresale.sn" placeholder="请选择" style="width: 100%" filterable default-first-option clearable @change="snChange">
                        <el-option v-for="(item,key) in inteboDeviceData" :value="item.sn" :label="'SN码:'+item.sn+' 完成业绩:'+item.perf" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="使用店销次数" prop="usesalecount" v-if="isfinished && issalecount">
                    <el-radio-group v-model="intebostoresale.usesalecount">
                        <el-radio :label="0">不使用</el-radio>
                        <el-radio :label="1">使用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="开始日期" prop="fromdate">
                    <el-date-picker size="mini" :editable="false" style="width: 100%" @change="getDateDiff" v-model="intebostoresale.fromdate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="todate">
                    <el-date-picker size="mini" :editable="false" style="width: 100%" @change="getDateDiff" v-model="intebostoresale.todate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="市场总监" prop="header">
                    <el-select v-model="intebostoresale.header" placeholder="请选择" style="width: 100%" filterable default-first-option clearable>
                        <el-option v-for="(item,key) in staffData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作总监" prop="header">
                    <el-select v-model="operationData" placeholder="请选择" style="width: 100%" filterable default-first-option multiple clearable>
                        <el-option v-for="(item,key) in staffData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售天数" prop="saleday">
                    <el-input v-model="intebostoresale.saleday" readonly></el-input>
                </el-form-item>
                <el-form-item label="体验人数" prop="tynumber">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="intebostoresale.tynumber" @change="numberChange">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="成交人数" prop="dealnumber">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="intebostoresale.dealnumber" @change="numberChange">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="未成交" prop="notnumber">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="intebostoresale.notnumber">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="目标业绩" prop="targerperf">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="intebostoresale.targerperf">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="现金业绩" prop="realperf">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="intebostoresale.realperf" @change="realPerfChange">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="回款类型" prop="backtype">
                    <el-radio-group v-model="intebostoresale.backtype" @change="backTypeChange">
                        <el-radio :label="0">正常</el-radio>
                        <el-radio :label="1">购机比率</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="服务费" prop="fwlv" v-if="isfinished && issalecount==false && intebostoresale.backtype==0">
                    <el-input-number style="text-align: left;width: 100%" :precision="2" :controls="false" :min="0" size="mini" v-model="intebostoresale.fwlv" @change="fwChange">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="回款金额" prop="backamount">
                    <el-input v-model="intebostoresale.backamount" readonly></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input v-model="intebostoresale.remarks"></el-input>
                </el-form-item>
            </el-form>
        </el-main>
        <el-footer>
            <el-button type="primary" :loading="loading" @click="saveInteboStoreSale" style="width: 100%">保存</el-button>
        </el-footer>
    </el-container>
</template>
<script>
import intebosale from "./intebosale";

export default {
    data() {
        return {
            issalecount:false,
            intebossoperations:[],
            intebossoperation:{
                storeid:"",
                sysbillid:"",
                staffid:"",
            },
            rules: {
                saletype: [
                    {required: true, message: "选择销售类型", trigger: 'blur'},
                ],
                sn: [
                    {required: true, message: "选择SN码", trigger: 'blur'},
                ],
                fromdate: [
                    {required: true, message: "请选择开始日期", trigger: 'blur'},
                ],
                todate: [
                    {required: true, message: "请选择结束日期", trigger: 'blur'},
                ],
                tynumber: [
                    {required: true, message: "请输入体验人数", trigger: 'blur'},
                ],
                dealnumber: [
                    {required: true, message: "请输入成交人数", trigger: 'blur'},
                ],
                realperf: [
                    {required: true, message: "请输入实际业绩", trigger: 'blur'},
                ],
            },
            isfinished:false,
            inteboDevice:{},
            inteboDeviceData:[],
            parentstoreid:[],
            storeData:[],
            loading:false,
            operationData:[],
            staffData:[],
            intebostoresale:{
                parentid:"",
                storeid:"",
                sysbillid:"",
                sn:"",
                header:"",
                targerperf:0,
                saletype:0,
                saleday:0,
                fromdate:"",
                todate:"",
                tynumber:0,
                dealnumber:0,
                notnumber:0,
                realperf:0,
                backamount:0,
                fwlv:0,
                createtor:"",
                createtorname:"",
                createdate:"",
                usesalecount:0,
                backtype:0,
                remarks:"",
                finished:0,
            },
        }
    },
    created() {
        let sysbillid=this.$route.query.sysbillid;
        if(sysbillid){
            this.getInteboStoreSaleById(sysbillid);
        }
        else{
            this.getSysBillId();
        }
        this.getInteboStaffTrain();
        this.getInteboStoreStructs();

    },
    methods:{
        backTypeChange(){
            if(this.intebostoresale.backtype==1){
                let backamount=this.$mul(this.intebostoresale.realperf,this.inteboDevice.backlv);
                if(backamount>=this.inteboDevice.restamount){
                    backamount=this.inteboDevice.restamount;
                }
                this.intebostoresale.backamount=backamount;
            }
            else{
                this.realPerfChange();
            }
        },
        getInteboStoreById(storeid){
            this.$post("inteboStore/getInteboStoreById",{storeid:storeid}).then(res=>{
                if(res.sucess){
                    let obj=res.object;
                    if(this.$asNumber(obj.salecount)>0){
                        this.issalecount=true;
                    }
                }
            });
        },
        fwChange(){
            this.intebostoresale.backamount=this.$mul(this.intebostoresale.fwlv,this.intebostoresale.realperf);
        },
        getInteboDeviceBySn(){
            this.$post("intebosale/getInteboDeviceBySn",{sn:this.intebostoresale.sn}).then(res=>{
                this.inteboDevice=res.object;
            });
        },
        getInteboStoreSaleById(sysbillid){
            this.$post("intebosale/getInteboStoreSaleById",{sysbillid:sysbillid}).then(res=>{
                let obj=res.object;
                this.intebostoresale=obj.inteboStoreSale;
                if(obj.inteboSsOperations!=null && obj.inteboSsOperations.length>0) {
                    for (let val of obj.inteboSsOperations) {
                        this.operationData.push(val.staffid);
                    }
                    let arry = [];
                    arry.push(this.intebostoresale.parentid)
                    arry.push(this.intebostoresale.storeid);
                    this.$nextTick(function () {
                        this.parentstoreid=arry;
                    });
                }
                this.getInteboDeviceBySn();
                this.getIntebodeviceByStoreId(this.intebostoresale.storeid);
            });
        },
        numberChange(val){
            this.intebostoresale.notnumber=this.$asNumber(this.intebostoresale.tynumber)-this.$asNumber(this.intebostoresale.dealnumber);
        },
        saveInteboStoreSale() {
            if (!this.intebostoresale.parentid) {
                this.$message({message: "请先选择品牌信息", type: 'error'});
                return;
            }
            if (!this.intebostoresale.storeid) {
                this.$message({message: "请选择门店信息", type: 'error'});
                return;
            }
            if (this.intebostoresale.saletype < 1) {
                this.$message({message: "请选择销售类型", type: 'error'});
                return;
            }
            if (!this.intebostoresale.sn) {
                this.$message({message: "请选择SN码", type: 'error'});
                return;
            }
            if (!this.intebostoresale.fromdate) {
                this.$message({message: "请选择开始日期", type: 'error'});
                return;
            }
            if (!this.intebostoresale.todate) {
                this.$message({message: "请选择结束日期", type: 'error'});
                return;
            }
            if (this.intebostoresale.tynumber < 1) {
                this.$message({message: "请输入体验人数", type: 'error'});
                return;
            }
            if (this.intebostoresale.dealnumber < 1) {
                this.$message({message: "请输入成交人数", type: 'error'});
                return;
            }
            if (this.intebostoresale.realperf < 1) {
                this.$message({message: "请输入实际业绩", type: 'error'});
                return;
            }

            this.intebossoperations=[];

            if(this.operationData!=null && this.operationData.length>0){
                for(let v of this.operationData) {
                    let obj = this.$copy(this.intebossoperation);
                    obj.sysbillid = this.intebostoresale.sysbillid;
                    obj.staffid=v;
                    this.intebossoperations.push(obj);
                }
            }

            if(this.intebossoperations.length>0){
                for(let val of this.intebossoperations){
                    val.storeid=this.intebostoresale.storeid;
                }
            }

            let inteboStoreSaleVo={};
            inteboStoreSaleVo.inteboStoreSale=this.intebostoresale;
            inteboStoreSaleVo.inteboSsOperations=this.intebossoperations;
            this.$postw("intebosale/saveInteboStoreSale",inteboStoreSaleVo).then(res=>{
                if(res.sucess){
                    this.$router.push({path:'/intebostoresale'});
                    this.$message({message: "保存成功", type: 'success'});
                }
            });
            //this.intebostoersale

        },
        realPerfChange(val){
            if(!this.intebostoresale.sn){
                this.$message({message: "请先选择仪器SN码", type: 'error'});
                this.intebostoresale.realperf=0;
                return;
            }
            if(this.isfinished){
                if(this.intebostoresale.fwlv>0){
                    this.intebostoresale.backamount=this.$mul(this.intebostoresale.realperf,this.intebostoresale.fwlv);
                }
            }
            else{
                if(this.inteboDevice.hzmode==3 && this.inteboDevice.restamount>0){
                    let backamount=this.$mul(this.intebostoresale.realperf,this.inteboDevice.backlv);
                    if(backamount>=this.inteboDevice.restamount){
                        backamount=this.inteboDevice.restamount;
                    }
                    this.intebostoresale.backamount=backamount;
                }
            }
        },
        snChange(val){
            for(let device of this.inteboDeviceData){
                if(val==device.sn){
                    this.inteboDevice=device;
                }
            }
            if(this.$parseInt(this.inteboDevice.perf)>=400000){
                this.isfinished=true;
            }
        },
        getDateDiff(){
            if(this.intebostoresale.fromdate && this.intebostoresale.todate) {
                this.$post("intebosale/getDateDiff", {
                    fromdate: this.intebostoresale.fromdate,
                    todate: this.intebostoresale.todate
                }).then(res => {
                    if (res.sucess) {
                        this.intebostoresale.saleday = res.object+1;
                    }
                });
            }
        },
        getIntebodeviceByStoreId(storeid){
            this.$post("intebosale/getIntebodeviceByStoreId",{storeid:storeid}).then(res=>{
                if(res.sucess){
                    this.inteboDeviceData=res.object;
                    if(this.inteboDeviceData==null || this.inteboDeviceData.length<1){
                        this.$message({message: "没查询到该门店的仪器信息，请先去填写仪器销售信息", type: 'error'});
                        this.parentstoreid=[];
                        this.intebostoresale.storeid="";
                        this.intebostoresale.parentid="";
                        return;
                    }
                    else{
                        this.intebostoresale.parentid=val[0];
                        this.intebostoresale.storeid=val[1];
                        //说明该门店只有一台仪器，默认选择该仪器
                        if(this.inteboDeviceData.length==1){
                            this.inteboDevice=this.inteboDeviceData[0];
                            this.intebostoresale.sn=this.inteboDevice.sn;
                            if(this.$parseInt(this.inteboDevice.perf)>=400000){
                                this.isfinished=true;
                            }
                        }
                    }
                }
            });
        },
        storeChange(val){
            if(!val[1]){
                this.$message({message: "请选择具体门店，不能只选择品牌信息", type: 'error'});
                this.inteboDeviceData=[];
                this.parentstoreid=[];
                this.intebostoresale.storeid="";
                this.intebostoresale.parentid="";
                return;
            }
            let storeid=val[1];
            this.getInteboStoreById(storeid);
            this.getIntebodeviceByStoreId(storeid);
        },
        getSysBillId(){
            this.$post("product/getSysBillId").then(res=>{
                if(res.sucess){
                    this.intebostoresale.sysbillid=res.object;
                }
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        },
        getInteboStaffTrain(){
            this.$post("inteboStaff/getInteboStaffTrain").then(res=>{
                if(res.sucess){
                    this.staffData=res.object;
                }
            });
        },
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.storesale .el-input-number .el-input__inner {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/page/intebo/intebotab/addintebostoresale.vue